import { render } from "./ContentNode.vue?vue&type=template&id=164a99ba"
import script from "./ContentNode.vue?vue&type=script&lang=js"
export * from "./ContentNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__